import { z } from "zod";
import { emailSchema, nameSchema, phoneSchema } from "./commonSchemas";
import { InstitutionType, SignupPurpose } from "../constants/signupEnums";

export const signupSchema = z.object({
  name: nameSchema,
  institute_type: z.enum(Object.values(InstitutionType) as [string, ...string[]]),
  institute_name: z.string().min(1, "validation.affiliationRequired"),
  institute_country_id: z.string().min(1, "validation.countryRequired"),
  institute_state_id: z.string().min(1, "validation.stateRequired"),
  institute_city_id: z.string().min(1, "validation.cityRequired"),
  instutue_pincode: z.string().min(1, "validation.pincodeRequired"),
  designation_id: z.string().min(1, "validation.designationRequired"),
  phone: phoneSchema,
  email: emailSchema,
  purpose: z.enum(Object.values(SignupPurpose) as [string, ...string[]]),
});

export type SignupInput = z.infer<typeof signupSchema>;
